



































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { PRODUCT_PARAM_QUERIES } from '~/constants';
import { url } from '~/utils';
import { BooleanLike } from '~/enums';

export default defineComponent({
  components: {
    AppIcon,
    AppLink,
  },
  props: {
    // タグマスタから取得するタグ名リスト
    tagNameList: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    isOpenKeywordTags: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    return { PRODUCT_PARAM_QUERIES, BooleanLike, url, emit };
  },
});
